import { useMediaQuery } from 'react-responsive';
import { Trans, useTranslation } from 'next-i18next';
import { StrongText } from '@/components/StrongText';
import { PlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUpsellingGuard } from '@/shared/plan';
import { cn } from '@/utils';
import { useOpenBuildAiModal } from '../useOpenBuildAiModal';
import { useQuizList } from '../useQuizList';
import { AiFileButton } from './AiFileButton';
import { AiQueryButton } from './AiQueryButton';
import { AiWebsiteButton } from './AiWebsiteButton';
import { AiYoutubeButton } from './AiYoutubeButton';
export const BuildAiButtons = () => {
  const {
    quizList
  } = useQuizList();
  const isButtonFull = quizList.length === 0;
  const isFlexCol = useMediaQuery({
    maxWidth: '820px'
  });
  const hideBot = useMediaQuery({
    maxWidth: '580px'
  });
  const openBuildAiModal = useOpenBuildAiModal();
  const upsellingGuard = useUpsellingGuard();
  return <div className={cn(['mb-lg px-md py-lg tablet-sm:px-lg tablet-sm:pt-xl tablet-sm:pb-lg relative', 'flex flex-col gap-[12px] rounded-md border-1 border-assistive shadow-xs bg-default'])} data-sentry-component="BuildAiButtons" data-sentry-source-file="index.tsx">
      <Label hideBot={hideBot} isFlexCol={isFlexCol} data-sentry-element="Label" data-sentry-source-file="index.tsx" />
      <div className={cn('grid grid-cols-1 gap-sm tablet-sm:grid-cols-2')}>
        <AiQueryButton onOpenBuildAiModal={() => openBuildAiModal('none')} isFull={isButtonFull} data-sentry-element="AiQueryButton" data-sentry-source-file="index.tsx" />
        <AiFileButton onOpenBuildAiModal={() => upsellingGuard(() => openBuildAiModal('file'), {
        feature: 'AI_FROM_FILE',
        from: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiFileButton" data-sentry-source-file="index.tsx" />
        <AiYoutubeButton onOpenBuildAiModal={() => upsellingGuard(() => openBuildAiModal('youtube'), {
        feature: 'AI_FROM_YOUTUBE',
        from: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiYoutubeButton" data-sentry-source-file="index.tsx" />
        <AiWebsiteButton onOpenBuildAiModal={() => upsellingGuard(() => openBuildAiModal('website'), {
        feature: 'AI_FROM_WEBSITE',
        from: 'ai_buttons'
      })} isFull={isButtonFull} data-sentry-element="AiWebsiteButton" data-sentry-source-file="index.tsx" />
      </div>
    </div>;
};
const Label = (props: {
  hideBot: boolean;
  isFlexCol: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className={'flex items-center gap-3xs'} data-sentry-component="Label" data-sentry-source-file="index.tsx">
      <PlanBadge planType="BASIC" data-sentry-element="PlanBadge" data-sentry-source-file="index.tsx" />

      <span className={'break-keep text-start text-body-lg-bold text-default'}>
        <Trans t={t} i18nKey={'build.ai.recommendAiQuiz'} components={{
        Comp: <StrongText text={t('ai.resultDescription.accent')} />
      }} data-sentry-element="Trans" data-sentry-source-file="index.tsx" />
        {/*<QUIZ AI를 이용해 다양한 문제를 빠르게 만들어 보세요*/}
      </span>
      {!props.hideBot && <div className={'absolute right-[2%] tablet-sm:right-6'}>
          <img src="/assets/aiRobot.png" alt="" width={82} height={82} />
        </div>}
    </div>;
};